export default {
  sm: `
  With our own solid data center resistant to 
  power outages and earthquakes and 
  storage technology that safely distributes 
  and stores data backed up three times, we 
  have infrastructure that can be reliably 
  operated under any circumstances.    
  `,
  md: `
  With our own solid data center resistant to 
  power outages and earthquakes and storage
  technology that safely distributes and 
  stores data backed up three times, we have 
  infrastructure that can be reliably operated 
  under any circumstances.    
  `,
  lg: `
  With our own solid data center resistant to power outages 
  and earthquakes and storage
  technology that safely distributes and stores data backed 
  up three times, we have infrastructure that can be reliably 
  operated under any circumstances.    
  `,
  xxl: `
  With our own solid data center resistant to
  power outages and earthquakes and storage
  technology that safely distributes and stores
  data backed up three times, we have 
  infrastructure that can be reliably operated 
  under any circumstances.    
  `,
};
